import React, { useContext, useEffect, useState, useRef, useMemo } from "react";
import { Typography, Box, Grid } from '@mui/material';

const CoverPage = () => {
    return (
        <>
            <Box sx={{ flexGrow: 1, p: 2 }}>
                <Grid container spacing={2}>
                    <Grid size={{ xs: 12, md: 8 }}>
                        <Typography variant="h5">
                        Go Get Creative. Go Live. Go Big.
                        </Typography>
                        <Typography variant="body1">
                        Welcome to GGC.me, the platform built for bold creators and passionate communities. Whether you're a livestreamer, performer, gamer, educator—or just someone with something to say—your story starts here.
                        </Typography>
                    </Grid>
                    <Grid size={{ xs: 12, md: 4 }}>

                    </Grid>
                </Grid>
            </Box>
        </>
    )
}
export default CoverPage;